import { Component, Vue } from 'vue-property-decorator';
import { CustomTableParams } from '@/models/custom-table-params.model';
import { BusinessService } from '@/services';
import { CustomBusiness } from '@/models/custom-business.model';
import { APP } from '@/constants';
import { BUSINESS, PERMISSIONS } from '@/constants';

@Component
export default class ListView extends Vue {

    public inFlight: boolean = false;
    public businesses: CustomBusiness[] = [];
    public filter: string;
    public cities: string[] = [];
    public categories: string[] = BUSINESS.TYPE_OPTIONS;

    public tableParams: CustomTableParams = null;

    private async getData(tableParams: CustomTableParams) {
        this.inFlight = true;
        try {
            const response = await BusinessService.publicList(tableParams);
            this.businesses = response.data.content;
            this.inFlight = false;
        } catch (error) {
            this.inFlight = false;
        }
    }

    private async getCities() {
        this.inFlight = true;
        try {
            const response = await BusinessService.getCities();
            this.cities = response.data;
            this.inFlight = false;
        } catch (error) {
            this.inFlight = false;
        }
    }

    public mounted() {
        this.tableParams = this.getQueryParams();
        this.getData(this.tableParams);
        this.getCities();
    }

    public getLogoUrl(business: CustomBusiness): string {
        if (business && business.logo) {
            return `${APP.API_URL}/storage/business-logos/${business.uuid}/${business.logo}`;
        } else {
            return '';
        }
    }

    public getTrimmedDescription(business: CustomBusiness) {
        if (business.general_description && business.general_description.length > 300) {
            return business.general_description.substr(0, 297) + '...';
        } else if (business.general_description && business.general_description.length) {
            return business.general_description;
        } else {
            return '';
        }
    }

    private setQueryParams(newTableParams: CustomTableParams) {
        const query = {
            page: `${newTableParams.page}`,
            size: `${newTableParams.size}`,
            filter: null,
        };

        if (newTableParams.filter && newTableParams.filter.length) {
            query.filter = newTableParams.filter.map((item) => encodeURI(JSON.stringify(item)));
        } else {
            delete query.filter;
        }

        this.$router.push({
            query,
        });
    }

    private getQueryParams(): CustomTableParams {
        const query = {
            size: 1500,
            page: 1,
            filter: null,
        };

        const queryFilter = this.$route.query.filter;
        if (queryFilter && queryFilter.length) {
            if (Array.isArray(queryFilter)) {
                query.filter = queryFilter.map((filterItem) => JSON.parse(decodeURI(filterItem)));
            } else {
                query.filter = [JSON.parse(decodeURI(queryFilter))];
            }
        }

        return query;
    }

    public setFilter(id, value) {
        const currentParams = { ...this.tableParams };
        let currentFilter = currentParams.filter;
        if (!currentFilter) {
            currentFilter = [];
        }

        const foundAt = currentFilter.findIndex((item) => item.id === id);

        if (foundAt >= 0) {
            currentFilter.splice(foundAt, 1);
        }

        if (value !== null && value !== undefined && value.length > 0) {
            currentFilter.push({
                id,
                value,
            });
        }

        currentParams.filter = [...currentFilter];
        currentParams.page = 1;
        this.handleTableParamsChanged(currentParams);
    }

    public getFilter(id) {
        if (!this.tableParams || !this.tableParams.filter || !this.tableParams.filter.length) {
            return null;
        }

        const foundAt = this.tableParams.filter.findIndex((item) => item.id === id);
        if (foundAt >= 0) {
            return this.tableParams.filter[foundAt].value;
        }
        return null;
    }

    public handleTableParamsChanged(newTableParams: CustomTableParams) {
        this.tableParams = { ...newTableParams };
        this.setQueryParams(newTableParams);
        this.getData(newTableParams);
    }


}
